/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';
import { POSITION_FIELDS } from '../../fragments';
import {
  AddPositionProps, RemovePositionProps, ResetPositionProps, UpdatePositionProps,
  ResetPositionByStaffIdProps,
} from './position.types';
import { PositionType } from '../../../types';

export const ADD_POSITION = gql`
  ${POSITION_FIELDS}
  mutation AddPosition(
  $jobId: ID!,
  $staffId: ID) {
    addPosition(
    jobId: $jobId,
    staffId: $staffId,
    ){
      ...PositionFields
    }
  }
`;

export function addPosition({
  client,
  staffId,
  jobId,
}: AddPositionProps) {
  return client?.mutate<{ addPosition: PositionType }>({
    mutation: ADD_POSITION,
    variables: {
      staffId,
      jobId,
    },
  });
}

export const RESET_POSITION_BY_STAFF_ID = gql`
  ${POSITION_FIELDS}
  mutation ResetPositionByStaffId (
  $staffId: ID!,
  ){
    resetStaffPosition(
    staffId: $staffId
    ){
      ...PositionFields
    }
  }
`;

export function resetPositionByStaffId({
  client,
  staffId,
}: ResetPositionByStaffIdProps) {
  return client?.mutate<{ resetStaffPosition: PositionType }>({
    mutation: RESET_POSITION_BY_STAFF_ID,
    variables: {
      staffId,
    },
  });
}

export const UPDATE_POSITION = gql`
  ${POSITION_FIELDS}
  mutation UpdatePosition(
  $positionId: ID!,
  $staffId: ID!,
  ){
    updateJobPosition(
    positionId: $positionId,
    staffId: $staffId,
    ){
      ...PositionFields
    }
  }
`;

export function updatePosition({
  client,
  staffId,
  positionId,
}: UpdatePositionProps) {
  return client?.mutate<{ updateJobPosition: PositionType }>({
    mutation: UPDATE_POSITION,
    variables: {
      staffId,
      positionId,
    },
  });
}

export const RESET_POSITION = gql`
  ${POSITION_FIELDS}
  mutation ResetPosition(
  $positionId: ID!,
  ){
    resetPosition(
    positionId: $positionId,
    ){
      ...PositionFields
    }
  }
`;

export function resetPosition({
  client,
  positionId,
}: ResetPositionProps) {
  return client?.mutate<{ resetPosition: PositionType }>({
    mutation: RESET_POSITION,
    variables: {
      positionId,
    },
  });
}

export const REMOVE_POSITION = gql`
  mutation removePosition(
  $positionId: ID!
  ){
    removePosition(
    positionId: $positionId
    )
  }
`;
export function removePosition({
  client,
  positionId,
}: RemovePositionProps) {
  return client?.mutate<{ removePosition: void }>({
    mutation: REMOVE_POSITION,
    variables: {
      positionId,
    },
  });
}
